import { useRef, memo, useMemo } from 'react';
import { cleanClass } from '@shared/utils/cleanClass.js';
import { randomId } from '@shared/utils/randomId.js';
import IconV2 from '@/components/v2/IconV2.jsx';
import FloatingSelectV2 from '@/components/v2/FloatingSelectV2.jsx';
import TextWithEllipsis from '@/components/TextWithEllipsis';

const Tag = memo(({ children, options, onChange, icon, iconPosition = 'left', variant = 'default', iconVariant = 'light', title, className = '', size = 'sm', onClick, value, useSearch, ...props }) => {
  const id = useRef(randomId());

  const optionLabel = useMemo(() => {
    return !value ? undefined : String(options?.find((n) => n?.value === value)?.label);
  }, [value, options]);

  return (
    <>
      <div className={cleanClass(`comp-tag ${variant} id-${id.current} size-${size} ${onClick ? 'clickable' : ''} ${className}`)} onClick={onClick} data-title={title} {...props}>
        {icon && iconPosition === 'left' && <IconV2 icon={icon} variant={iconVariant} />}
        {(!!optionLabel || !!children) && <TextWithEllipsis>{optionLabel || children}</TextWithEllipsis>}
        {icon && iconPosition === 'right' && <IconV2 icon={icon} variant={iconVariant} />}
      </div>
      {!!options?.length && <FloatingSelectV2 triggers={[`.comp-tag.id-${id.current}`]} options={options} onChange={onChange} useSearch={useSearch} />}
    </>
  );
});

Tag.displayName = 'Tag';

export default memo(Tag);
